import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiDrawer(theme: Theme): Components['MuiDrawer'] {
  return {
    styleOverrides: {
      root: {
        zIndex: theme.zIndex.drawer,
      },
    },
  };
}
